<template>
    <DxDataGrid :data-source="dsOrganigramaDetalii" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id" @row-click="onRowClick">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>

        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" width="500px" height="550px" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid>
                <DxItem data-field="Cod" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Nume" :editor-options="{ height: 50 }"/>
                <DxItem data-field="StareID" editor-type="dxSelectBox" 
                        :editor-options="{dataSource: dsOrganigrameStari, 
                        displayExpr: 'Nume', 
                        valueExpr: 'Id', 
                        placeholder: 'Selectează o stare...',
                        height: 50,
                        showClearButton: true}"/>
                <DxItem data-field="PunctID" editor-type="dxSelectBox" 
                        :editor-options="{dataSource: dsPuncte, 
                        displayExpr: 'Nume', 
                        valueExpr: 'Id', 
                        placeholder: 'Selectează un punct...',
                        height: 50,
                        showClearButton: true}"/>
                <DxItem data-field="Versiune" editor-type="dxNumberBox" :editor-options="numberBoxOptions"/> 
                <DxItem data-field="AprobareDocument" :editor-options="{ height: 50 }"/>
                <DxItem data-field="ValidData" :editor-options="{ height: 50, displayFormat: 'dd-MM-yyyy' }"/>
                <DxItem data-field="AprobareData"  :editor-options="{ height: 50, displayFormat: 'dd-MM-yyyy' }"/>
                <DxItem data-field="Observatii" :col-span=2 :editor-options="{ height: 50 }"/>
            </DxFormGrid>
        </DxEditing>

        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Detaliu
            </div>
        </template>

        <DxColumn data-field="Cod" caption="Cod"/>
        <DxColumn data-field="Nume" caption="Nume"/>
        <DxColumn data-field="StareID" caption="Stare" calculate-display-value="Stare.Nume"/>
        <DxColumn data-field="Versiune" caption="Versiune"/>
        <DxColumn data-field="ValidData" caption="Valid Data" data-type="date"/>
        <DxColumn data-field="AprobareDocument" caption="Aprobare Document"/>
        <DxColumn data-field="AprobareData" caption="Aprobare Data" data-type="date"/>
        <DxColumn data-field="Observatii" caption="Observatii"/>
        <DxColumn data-field="PunctID" caption="Punct de Lucru" calculate-display-value="Punct.Nume">
            <DxLookup 
                :data-source="dsPuncte"
                value-expr="Id"
                display-expr="Nume"/>
        </DxColumn>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="500px" height="550px">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Detaliu
            </div>
        </template>
        <DxForm :col-count="2">
            <DxSimpleItem data-field="Cod" :is-required="true">
                <template #default>
                    <DxTextArea :value="newOrganigramaDetaliu.Cod" @value-changed="onCodValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newOrganigramaDetaliu.Nume" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Stare">
                <template #default>
                    <DxLookup :data-source="dsOrganigrameStari"
                              display-expr="Nume"
                              value-expr="Id"
                              :value="newOrganigramaDetaliu.StareID"
                              @value-changed="onStareIDValueChanged"
                              height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Punct">
                <template #default>
                    <DxLookup :data-source="dsPuncte"
                              display-expr="Nume"
                              value-expr="Id"
                              :value="newOrganigramaDetaliu.PunctID"
                              @value-changed="onPunctIDValueChanged"
                              height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Versiune">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newOrganigramaDetaliu.Versiune" @value-changed="onVersiuneValueChanged" height="50px"/>
                </template>
            </DxSimpleItem> 
            <DxSimpleItem data-field="Aprobare Document">
                <template #default>
                    <DxTextArea :value="newOrganigramaDetaliu.AprobareDocument" @value-changed="onAprobDocValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Valid Data">
                <template #default>
                    <DxDateBox :value="newOrganigramaDetaliu.ValidData" type="date" display-format="dd-MM-yyyy" :show-clear-button="true" 
                    label-mode="floating" height="50px" @value-changed="onValidDataValueChanged"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Aprobare Data">
                <template #default>
                    <DxDateBox :value="newOrganigramaDetaliu.AprobareData" type="date" display-format="dd-MM-yyyy" :show-clear-button="true" 
                    label-mode="floating" height="50px" @value-changed="onAprobDataValueChanged"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Observatii" :col-span="2">
                <template #default>
                    <DxTextArea :value="newOrganigramaDetaliu.Observatii" @value-changed="onObservatiiValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem,
  DxItem as DxFormItem,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
  DxSearchPanel,
  DxMasterDetail
} from 'devextreme-vue/data-grid';
import DxDateBox from 'devextreme-vue/date-box';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextArea from 'devextreme-vue/text-area';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxLookup } from 'devextreme-vue/lookup';
import { DxNumberBox } from "devextreme-vue/number-box";
import RU_Organigrama from '@/services/RU/RU_Organigrama';

export default defineComponent({
    components: {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxValidationRule,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxPopupAdd,
        DxSimpleItem,
        DxTextArea,
        DxCheckBox,
        DxToolbarItem,
        DxPopup,
        DxFormGrid,
        DxFormItem,
        DxMasterDetail,
        DxLookup,
        DxNumberBox,
        DxDateBox
    },
    props: {
        templateData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return  {
            dsOrganigramaDetalii: {} as DataSource,
            dataGridRef: null as any,
            dsOrganigrameStari: new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `RU_OrganigrameStari`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            }),
            dsPuncte: new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `ERP_Puncte`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                }
            }),
            newOrganigramaDetaliu: {
                OrganigramaID: null,
                Cod: '',
                Nume: '',
                StareID: null,
                Versiune: null,
                ValidData: null,
                AprobareDocument: null,
                AprobareData: null,
                Observatii: null,
                PunctID: null
            },
            addPopupVisible: false,
            editPopupVisible: false,
            addButtonOptions: {
                type: "success", 
                text: "Salvează", 
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success", 
                text: "Salvează", 
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger", 
                text: "Închide", 
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            dangerButtonOptions: {
                type: "danger", 
                text: "Închide", 
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            numberBoxOptions: {
                min: 0,
                step: 1,
                showSpinButtons: true,
                showClearButton: true,
                height: 50
            },
        }
    },
    mounted() {
        this.dsOrganigramaDetalii = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `RU_OrganigramaDetalii`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                    e.params.$expand = "Stare($select=Cod,Nume),Punct($select=Cod,Nume)"
                },
            },
            filter: ['OrganigramaID', '=', this.templateData.key]
        })
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        this.setDeleteConfirmationMessage()
    },
    methods: {
        onCloseAdd() {
            this.addPopupVisible = false
            this.newOrganigramaDetaliu.Cod = ''
            this.newOrganigramaDetaliu.Nume = ''
            this.newOrganigramaDetaliu.StareID = null
            this.newOrganigramaDetaliu.PunctID = null
            this.newOrganigramaDetaliu.Versiune = null
            this.newOrganigramaDetaliu.AprobareDocument = null
            this.newOrganigramaDetaliu.AprobareData = null
            this.newOrganigramaDetaliu.Observatii = null
            this.newOrganigramaDetaliu.ValidData = null
        },
        onRefreshClick() {
            const gridInstance = this.dataGridRef?.instance;
            if (gridInstance) {
                gridInstance.refresh();
                notify("Datele au fost actualizate cu succes!", "success", 3000);
            }
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        closeEditPopup() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onAddClick() {
            this.addPopupVisible = true
        },
        async onSaveEdit() {
            const gridInstance = this.dataGridRef?.instance;
            if (!gridInstance) {
                notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                return; 
            }
            try {
                gridInstance.saveEditData()
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error("Eroare la salvarea editării:", error);
            }
        },
        onStareIDValueChanged(e: any) {
            this.newOrganigramaDetaliu.StareID = e.value
        },
        onCodValueChanged(e: any) {
            this.newOrganigramaDetaliu.Cod = e.value
        },
        onNumeValueChanged(e: any) {
            this.newOrganigramaDetaliu.Nume = e.value
        },
        onVersiuneValueChanged(e: any) {
            this.newOrganigramaDetaliu.Versiune = e.value
        },
        onAprobDocValueChanged(e: any) {
            this.newOrganigramaDetaliu.AprobareDocument = e.value
        },
        onAprobDataValueChanged(e: any) {
            this.newOrganigramaDetaliu.AprobareData = e.value
        },
        onObservatiiValueChanged(e: any) {
            this.newOrganigramaDetaliu.Observatii = e.value
        },
        onPunctIDValueChanged(e: any) {
            this.newOrganigramaDetaliu.PunctID = e.value
        },
        onValidDataValueChanged(e: any) {
            this.newOrganigramaDetaliu.ValidData = e.value
        },
        onSaveAdd() {
            if (!this.newOrganigramaDetaliu.Cod || this.newOrganigramaDetaliu.Cod.trim() === "") {
                notify("Vă rog să completați câmpul obligatoriu 'Cod'!", "error", 3000)
                return
            }
            if (!this.newOrganigramaDetaliu.Nume || this.newOrganigramaDetaliu.Nume.trim() === "") {
                notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                return
            }
            if (this.newOrganigramaDetaliu.StareID === null) {
                notify("Vă rog să completați câmpul obligatoriu 'Stare'!", "error", 3000)
                return
            }
            if (this.newOrganigramaDetaliu.PunctID === null) {
                notify("Vă rog să completați câmpul obligatoriu 'Punct de lucru'!", "error", 3000)
                return
            }

            this.newOrganigramaDetaliu.OrganigramaID = this.templateData.key
            RU_Organigrama.saveDetalii(this.newOrganigramaDetaliu).then((detaliu) => {
                this.addPopupVisible = false
                notify('Datele au fost salvate cu succes!', 'success', 2000)
                this.newOrganigramaDetaliu = {
                    OrganigramaID: null,
                    Cod: '',
                    Nume: '',
                    StareID: null,
                    Versiune: null,
                    AprobareDocument: '',
                    AprobareData: null,
                    Observatii: '',
                    ValidData: null,
                    PunctID: null
                }
                this.onRefreshClick()
            }).catch((error) => {
                console.error(error)
            })
        },
        onRowClick(e: any) {
            const organigramaId = e.data.Id
            this.$router.push({ 
                name: 'TreeOrganigrama', 
                params: { id: organigramaId } 
            });
        }
    }
})
</script>